<template>
  <div>
    <a-input-search placeholder="请输入标题搜索..." style="width: 300px" v-model.trim="keyWord" @search="onSearch" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyWord: '',
    }
  },
  created() {
    const flag = this.$route.query.key
    if (flag) this.keyWord = flag
  },
  methods: {
    onSearch(value) {
      const flag = this.$route.query.key
      console.log(flag,this.keyWord);
      if (flag === undefined) {
        console.log('undefined---->')
        this.$router.replace({
          path: '/searchResult',
          query: {
            key: this.keyWord,
          },
        })
      } else {
        setTimeout(() => {
          console.log('emit', this.keyWord, flag)
          if (flag !== this.keyWord) {
            this.$router.replace({
              path: '/searchResult',
              query: {
                key: this.keyWord,
              },
            })
            this.$bus.$emit('keyword', this.keyWord)
          }
        }, 0)
      }
    },
  },
}
</script>

<style lang="less" scoped>
</style>